import React, { useEffect, useState } from 'react';
import CasualConditions from './modal-content/casual-conditions';
import Modal from './modal';
import ProductList from './product-list';
import SkipBinConditions from './modal-content/skip-bin-conditions';
import DeclineMessage from './modal-content/decline-message';
import AcceptanceDialog from './modal-content/acceptance-dialog';
import InorganicConditions from './modal-content/inorganic-conditions';
import { ACCEPTED, DECLINED, CANCELLED } from '../variables';
import QuoteAcceptanceControl from './quote-acceptance-control';
import { useBookingContext } from '../context/BookingContext';

const QuotePanel = () => {

    const { booking, declineBooking } = useBookingContext();

    const purchaseOrder = booking?.po || '';
    const jobs = booking?.futureJobs || [];
    const paid = booking?.paid || false;
    const bookingStatus = booking?.bookingStatus;
    const accepted = bookingStatus === ACCEPTED;
    const declined = bookingStatus === DECLINED;
    const cancelled = bookingStatus === CANCELLED;
    const bookingId = booking?.id || '';

    // Disable checkboxes if booking is finalized (accepted, declined, cancelled, or paid)
    const isFinalized = accepted || declined || cancelled || paid;

    const [showSkipBinConditions, setShowSkipBinConditions] = useState(false);
    const [showInorganicConditions, setShowInorganicConditions] = useState(false);
    const [showCasualConditions, setShowCasualConditions] = useState(false);
    const [containsSkipBinJob, setContainsSkipBinJob] = useState(false);
    const [containsInorganicJob, setContainsInorganicJob] = useState(false);
    const [containsCasualJob, setContainsCasualJob] = useState(false);
    const [skipBinConditionsAccepted, setSkipBinConditionsAccepted] = useState(false);
    const [casualConditionsAccepted, setCasualConditionsAccepted] = useState(false);
    const [inorganicConditionsAccepted, setInorganicConditionsAccepted] = useState(false);
    const [showAcceptModal, setShowAcceptModal] = useState(false);
    const [casualConditionsNotAccepted, setCasualConditionsNotAccepted] = useState(false);
    const [skipBinConditionsNotAccepted, setSkipBinConditionsNotAccepted] = useState(false);
    const [inorganicConditionsNotAccepted, setInorganicConditionsNotAccepted] = useState(false);
    const [showDeclineModal, setShowDeclineModal] = useState(false);

    useEffect(() => {
        if (jobs.some(job => job.type === 3)) {
            setContainsSkipBinJob(true);
        }
        if (jobs.some(job => job.type === 2)) {
            setContainsInorganicJob(true);
        }
        if (jobs.some(job => job.type === 1)) {
            setContainsCasualJob(true);
        }
    }, [jobs])

    useEffect(() => {
        if (paid) {
            setSkipBinConditionsAccepted(true);
            setCasualConditionsAccepted(true);
            setInorganicConditionsAccepted(true);
        }
    }, [paid])

    useEffect(() => {
        if (accepted) {
            setCasualConditionsAccepted(true);
            setSkipBinConditionsAccepted(true);
            setInorganicConditionsAccepted(true);
        }
    }, [accepted])

    const toggleSkipBinCheck = () => {
        setSkipBinConditionsAccepted(!skipBinConditionsAccepted);
        setSkipBinConditionsNotAccepted(false);
    }

    const toggleCasualCheck = () => {
        setCasualConditionsAccepted(!casualConditionsAccepted);
        setCasualConditionsNotAccepted(false);
    }

    const toggleInorganicCheck = () => {
        setInorganicConditionsAccepted(!inorganicConditionsAccepted);
        setInorganicConditionsNotAccepted(false);
    }

    const handleAccept = () => {
        let allConditionsAccepted = true;
        if (containsCasualJob) {
            if (!casualConditionsAccepted) {
                allConditionsAccepted = false
                setCasualConditionsNotAccepted(true);
            }
        }
        if (containsSkipBinJob) {
            if (!skipBinConditionsAccepted) {
                allConditionsAccepted = false;
                setSkipBinConditionsNotAccepted(true);
            }
        }
        if (containsInorganicJob) {
            if (!inorganicConditionsAccepted) {
                allConditionsAccepted = false;
                setInorganicConditionsNotAccepted(true);
            }
        }
        if (allConditionsAccepted) {
            setShowAcceptModal(true);
        }
    }

    const handleDecline = () => {
        declineBooking(bookingId);
        setShowDeclineModal(true);
    }

    return (
        <div className="w-full lg:w-2/5 lg:min-h-screen bg-gray-100 lg:fixed lg:right-0 lg:top-0 lg:h-screen overflow-y-auto flex flex-col lg:justify-center">
            <div className="h-2 lg:h-auto"></div>
            <div className="mx-auto w-11/12 sm:w-3/4 text-gray-700">
                <div>
                    Booking Reference: {bookingId}
                </div>
                <div>
                    {purchaseOrder !== "" ? <div>Purchase Order: {purchaseOrder}</div> : null}
                </div>
            </div>
            <ProductList />
            { containsCasualJob ?
                <div className="w-11/12 sm:w-3/4 mx-auto text-gray-700 cursor-default font-light py-2 text-sm sm:text-base">
                    <div className={"border border-red-700 px-1.5 inline-block w-auto rounded-md " + (casualConditionsNotAccepted ? "border-opacity-100" : "border-opacity-0")}>
                        <input className="mr-2" type="checkbox" checked={casualConditionsAccepted} onChange={toggleCasualCheck} disabled={isFinalized}></input>
                        I have read and accepted the<span> </span>
                        <span className="text-blue-800 underline cursor-pointer" onClick={() => setShowCasualConditions(true)}>conditions</span>
                        <span> </span>
                        for casual hire.
                    </div>
                    {casualConditionsNotAccepted ?
                        <div className="text-red-700 text-sm px-3 flex items-center">
                            <svg className="h-4 w-4 inline" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                                <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                            </svg>
                            <div className="pl-1 inline">
                                Conditions need to be accepted to continue.
                            </div>
                        </div> : <div></div>
                    }

                </div>
                : <div></div>
            }
            {
                containsInorganicJob ?
                <div className="w-11/12 sm:w-3/4 mx-auto text-gray-700 cursor-default font-light py-2 text-sm sm:text-base">
                <div className={"border border-red-700 px-1.5 inline-block w-auto rounded-md " + (inorganicConditionsNotAccepted ? "border-opacity-100" : "border-opacity-0")}>
                    <input className="mr-2" type="checkbox" checked={inorganicConditionsAccepted} onChange={toggleInorganicCheck} disabled={isFinalized}></input>
                    I have read and accepted the <span> </span>
                    <span className="text-blue-800 underline cursor-pointer" onClick={() => setShowInorganicConditions(true)}>conditions</span>
                    <span> </span>
                    of inorganic collection.
                </div>
                {inorganicConditionsNotAccepted ?
                    <div className="text-red-700 text-sm px-3 flex items-center">
                        <svg className="h-4 w-4 inline" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                            <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                        </svg>
                        <div className="pl-1 inline">
                            Conditions need to be accepted to continue.
                    </div>
                    </div> : <div></div>
                }
                </div>
                : <div></div>
            }
            { containsSkipBinJob ?
                <div className="w-11/12 sm:w-3/4 mx-auto text-gray-700 cursor-default font-light py-2 text-sm sm:text-base">
                    <div className={"border border-red-700 px-1.5 inline-block w-auto rounded-md " + (skipBinConditionsNotAccepted ? "border-opacity-100" : "border-opacity-0")}>
                        <input className="mr-2" type="checkbox" checked={skipBinConditionsAccepted} onChange={toggleSkipBinCheck} disabled={isFinalized}></input>
                        I have read and accepted the <span> </span>
                        <span className="text-blue-800 underline cursor-pointer" onClick={() => setShowSkipBinConditions(true)}>conditions</span>
                        <span> </span>
                        of skip bin hire.
                    </div>
                    {skipBinConditionsNotAccepted ?
                        <div className="text-red-700 text-sm px-3 flex items-center">
                            <svg className="h-4 w-4 inline" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                                <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                            </svg>
                            <div className="pl-1 inline">
                                Conditions need to be accepted to continue.
                        </div>
                        </div> : <div></div>
                    }
                </div>
                : <div></div>
            }
            <QuoteAcceptanceControl acceptCallback={handleAccept} declineCallback={handleDecline} />
            <div className="w-full text-center text-gray-400 text-sm mt-10 mb-20">
                <span className="text-center">0800 36 77 35 | info@rubbishdirect.co.nz | www.rubbishdirect.co.nz</span>
            </div>

            <Modal
                height="h-screen"
                width="w-full md:w-4/5 lg:w-3/5"
                show={showSkipBinConditions}
                closeModal={() => setShowSkipBinConditions(false)}
            >
                <SkipBinConditions />
            </Modal>
            <Modal
                height="h-screen"
                width="w-full md:w-4/5 lg:w-3/5"
                show={showInorganicConditions}
                closeModal={() => setShowInorganicConditions(false)}
            >
                <InorganicConditions />
            </Modal>
            <Modal
                height="h-screen"
                width="w-full md:w-4/5 lg:w-3/5"
                show={showCasualConditions}
                closeModal={() => setShowCasualConditions(false)}
            >
                <CasualConditions />
            </Modal>
            <Modal
                height="h-screen"
                width="w-screen"
                show={showAcceptModal}
                closeModal={() => setShowAcceptModal(false)}
            >
                <AcceptanceDialog closeCallback={() => setShowAcceptModal(false)} />
            </Modal>
            <Modal
                height="h-screen"
                width="w-screen"
                show={showDeclineModal}
                closeModal={() => setShowDeclineModal(false)}
            >
                <DeclineMessage />
            </Modal>
        </div>
    )
}

export default QuotePanel;
